import { findIndex, sortBy } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import {
  MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT,
  MINIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT,
} from '../../../constants/service/app/recommendEventConstants';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../constants/service/common/utilConstants';
import { asyncSimpleModal } from '../../../lib/common';
import { recommendEventActions } from '../../../store/modules/recommend/event';
import RecommendEventSaveWrap from '../../../views/recommend/event/save/RecommendEventSaveWrap';

class RecommendEventSaveContainer extends Component {
  /**
   *  추천 기획전 복사하기
   */
  onSubmit = () => {
    const { form, recommendEventSave, createRecommendEvent } = this.props;
    const { recommendEventInfo, recommendEventItemList } = recommendEventSave;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) return;

      /**
       *  추천 기획전 아이템 최소 개수 체크
       */
      if (recommendEventItemList.selectedItemList.list.length < MINIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT) {
        message.error(`추천 기획전 아이템은 최소 ${MINIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT}개이상입니다.`);
        return;
      }

      createRecommendEvent({
        /**
         *  추천 기획전 정보
         */
        recommendEventInfo: {
          /**
           *  추천 기획전 타입
           */
          type: recommendEventInfo.type,
          /**
           *  메모
           */
          memo: recommendEventInfo.memo,
        },
        /**
         *  추천 기획전에 연결된 기획전 id 리스트
         */
        recommendEventItemIdList: recommendEventItemList.selectedItemList.idList,
      });
    });
  };

  /**
   *  추천 기획전에 연결할 아이템 리스트 불러오기
   */
  getRecommendEventItemList = (option) => {
    const { getRecommendEventItemList, recommendEventSave } = this.props;
    const { recommendEventItemList } = recommendEventSave;
    const { filterOption, sortOption, pagination } = recommendEventItemList.itemList;

    getRecommendEventItemList({
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  추천 기획전에 연결할 아이템 선택하기
   */
  selectRecommendEventItemList = async (action, moveIdList) => {
    const { setData, recommendEventSave } = this.props;
    const { recommendEventItemList } = recommendEventSave;
    const { itemList, selectedItemList } = recommendEventItemList;

    /**
     *  업데이트 될 선택된 연결할 아이템 리스트
     */
    let updatedSelectRecommendEventItemList = [];

    /**
     *  연결할 아이템 아이템 추가
     */
    if (action === 'add') {
      let targetList = itemList.list.filter((item) => moveIdList.includes(item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 아이템을 합침
       */
      updatedSelectRecommendEventItemList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 아이템 개수가 초과되었을 경우
       */
      if (updatedSelectRecommendEventItemList.length > MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT) {
        await asyncSimpleModal({
          type: 'error',
          title: '아이템 개수 초과',
          message: `추천 기획전 아이템 개수는 최대 ${MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT} 입니다.`,
        });
        return;
      }
    } else if (action === 'remove') {
      /**
       *  연결할 아이템 아이템 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      updatedSelectRecommendEventItemList = selectedItemList.list.filter((item) => !moveIdList.includes(item.id));
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedRecommendEventItemList = itemList.list.map((item) => ({
      ...item,
      uncheckable: moveIdList.includes(item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['recommendEventSave', 'recommendEventItemList', 'itemList', 'list'],
      value: updatedRecommendEventItemList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['recommendEventSave', 'recommendEventItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendEventItemList,
        idList: updatedSelectRecommendEventItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  추천 검색 기획전 아이템 순서 변경하기
   */
  onDragEndSelectRecommendReviewItemList = async (newList) => {
    const { setData, recommendEventSave } = this.props;
    const { recommendEventItemList } = recommendEventSave;
    const { selectedItemList } = recommendEventItemList;

    const updatedSelectRecommendEventItemList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['recommendEventSave', 'recommendEventItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendEventItemList,
        idList: updatedSelectRecommendEventItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  전체 기획전 리스트 EXCEL 다운로드
   */
  getRecommendEventItemListExcelDownload = () => {
    const { getRecommendEventItemListExcelDownload, recommendEventSave } = this.props;
    const { recommendEventItemList } = recommendEventSave;
    const { filterOption, sortOption } = recommendEventItemList.itemList;

    getRecommendEventItemListExcelDownload({
      filterOption,
      sortOption,
    });
  };

  /**
   *  선택된 기획전 리스트 EXCEL 다운로드
   */
  getSelectedRecommendEventItemListExcelDownload = () => {
    const { getSelectedRecommendEventItemListExcelDownload, recommendEventSave } = this.props;
    const { recommendEventItemList } = recommendEventSave;
    const { idList } = recommendEventItemList.selectedItemList;

    if (!idList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getSelectedRecommendEventItemListExcelDownload({
      selectedRecommendEventItemIdList: idList,
    });
  };

  /**
   *  기획전 리스트 EXCEL 업로드
   */
  setRecommendEventItemListExcelUpload = (file) => {
    const { setRecommendEventItemListExcelUpload } = this.props;

    setRecommendEventItemListExcelUpload({
      attachment: [file],
    });
  };

  render() {
    const { form, recommendEventSave, setData, typeDisabled } = this.props;

    return (
      <RecommendEventSaveWrap
        form={form}
        setData={setData}
        recommendEventSave={recommendEventSave}
        typeDisabled={typeDisabled}
        getRecommendEventItemList={this.getRecommendEventItemList}
        selectRecommendEventItemList={this.selectRecommendEventItemList}
        onSubmit={this.onSubmit}
        onDragEndSelectRecommendReviewItemList={this.onDragEndSelectRecommendReviewItemList}
        getRecommendEventItemListExcelDownload={this.getRecommendEventItemListExcelDownload}
        getSelectedRecommendEventItemListExcelDownload={this.getSelectedRecommendEventItemListExcelDownload}
        setRecommendEventItemListExcelUpload={this.setRecommendEventItemListExcelUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    recommendEventSave: state.recommendEvent.recommendEventSave,
  };
};

const mapDispatchToProps = {
  setData: recommendEventActions.setData,
  getRecommendEventItemList: recommendEventActions.getRecommendEventItemList,
  createRecommendEvent: recommendEventActions.createRecommendEvent,
  getRecommendEventItemListExcelDownload: recommendEventActions.getRecommendEventItemListExcelDownload,
  getSelectedRecommendEventItemListExcelDownload: recommendEventActions.getSelectedRecommendEventItemListExcelDownload,
  setRecommendEventItemListExcelUpload: recommendEventActions.setRecommendEventItemListExcelUpload,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(RecommendEventSaveContainer));
